
import  { isNullOrEmpty } from "../../../../utils/common"
import  { 
    ERROR_EMPTY_USERNAME,
    ERROR_EMPTY_LOGINID,
    ERROR_EMPTY_PASSWORD,
    ERROR_MINIMUM_LOGINID,
    ERROR_MINIMUM_PASSWORD,
    ERROR_LOGINID_PASSWORD
} from "../../../../utils/messages"

function validate(payload){

    let prompt = [];
    let minLength = 8;
    let maxLength = 16;

    if(isNullOrEmpty(payload.userName)){
        prompt.push(ERROR_EMPTY_USERNAME);
    }

    if(isNullOrEmpty(payload.loginId)){
        prompt.push(ERROR_EMPTY_LOGINID);
    }else if(payload.loginId.length < minLength || payload.loginId.length > maxLength){
        prompt.push(ERROR_MINIMUM_LOGINID);
    }

    if(isNullOrEmpty( payload.password)){
        prompt.push( ERROR_EMPTY_PASSWORD);
    }else if(payload.password.length < minLength || payload.password.length > maxLength){
        prompt.push(ERROR_MINIMUM_PASSWORD);
    }else if (payload.password === payload.loginId){
        prompt.push(ERROR_LOGINID_PASSWORD)
    }

    return prompt;
}


export{
    validate,
};